import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a028958f6558f001470a2ec/detailbook/src/app/sign-up-login/components/AuthScreen.tsx");
